import { render } from "./ProductViewer.vue?vue&type=template&id=d3532fa6&ts=true"
import script from "./ProductViewer.ts?vue&type=script&lang=ts"
export * from "./ProductViewer.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\bms_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__